import React, { Component } from "react";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import Util from "../../util.js";
import { isAllMonetaryCode, onMiniProgramDialog } from "../../common";
import ModalSelect from "../Modal/ModalSelect";
import { getPayAll, goLogin, getPayAllSuper } from "../../getPay";
import AlerModle from "./AlerModle";
import { getCondition, investNotCombination, getSuperFoundDetail, verifyActivityBool } from "../../action/investmentAction";
import NavigatorMain from "../NavigatorMain";
import NHeader from "../NHeader.js";
import ChangeFundListEntry from "../ChangeFundListEntry.js";
import BaseInformationStop from "../BaseInformationStop.js";
import { getStrategiesDetailsStop,strategiesDetailsDel, changeFundListDel } from "../../action/portfolioAction";
import StopPosition from "../StopPosition.js";
import { GuidePageType } from "../guidePage/index.js";
import Guide from '../guidePage';
import CacheHOC from "../HOC/StateCache.js"

class TargetProfitDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      openDate: "",
      dataval: null,
      subStatus: "",
      endDate: "",
      superData: "",
      isInvestmentAdvisory: false
    };
  }

  componentWillMount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "止盈组合未投详情", "进入"]);
    let { superFundCode, superFundName } = this.props.location.query;
    let len = Util.superFundCodeArrByTarget.indexOf(superFundCode);

    document.title = "策略详情";
  }
  componentWillUnmount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "止盈组合未投投详情", "离开"]);
    Guide.leave();
  }

  componentDidMount() {
    if(this.props.location.search.indexOf('appInvestmentAdvisory') !== -1){
      this.setState({isInvestmentAdvisory: true})
    }
    if (this.props.location.query.inviteCode) {
      window.localStorage.setItem("inviteCode", this.props.location.query.inviteCode);
    }
    // getStorage("shortToken",function(data){console.log(data,"**shortTokenshortTokenshortToken***")})
    let { dispatch } = this.props;

    let superFundCode = this.props.location.query.superFundCode ? this.props.location.query.superFundCode : "SF1003";
    let that = this;
    let data = {
      superFundCode,
    };
    // dispatch(getSuperFoundDetail(superFundCode));
    let objVal = {
      superFundCode: superFundCode,
      stopProfit: true,
    };
    dispatch(
      verifyActivityBool(objVal, (result) => {
        console.log(result);
        this.setState({
          subStatus: result.subStatus,
          endDate: result.activitySuperFund ? result.activitySuperFund.endDateStr : "",
          openDate: result.activitySuperFund ? result.activitySuperFund.startDateStr : "",
        });
      })
    );

    this.props.dispatch(
      getStrategiesDetailsStop({
        superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode,
      },(val)=>{this.setState({superData:val})})
    );
    document.body.scrollTo(0, 0);
  }
  callBack(data) {
    // document.getElementsByTagName('title')[0].innerHTML = data.productQueryResponse.superFundName
  }
  goBack() {
    hashHistory.goBack();
  }

  async goInvesting() {
    const isMiniProgram = onMiniProgramDialog(GuidePageType.Trade)
    if (isMiniProgram) return
    let route = window.history.length;
    let { dispatch, SuperFoundDetailXCL } = this.props;
    let {superData} = this.state
    let _this = this;
    let data = {
      superFundCode: _this.props.location.state ? _this.props.location.state.superFundCode : _this.props.location.query.superFundCode,
    };
    const fun = function () {
      let params = {
        fundCode: _this.props.location.state ? _this.props.location.state.superFundCode : _this.props.location.query.superFundCode,
        fundName: _this.props.location.state ? _this.props.location.state.superFundName : _this.props.location.query.superFundName,
        isShowModal: true, //首次购买弹窗标识
        // prompt: SuperFoundDetailXCL[0].prompt,
        policy:  superData.superFundPolicy?superData.superFundPolicy.policy?superData.superFundPolicy.policy:"":"",
        policyTitle: superData.superFundPolicy?superData.superFundPolicy.policyTitle?superData.superFundPolicy.policyTitle:"":"",
        productType: "Z",
        pageText: "无定投",
        superTypeValue: "1",
      };
      getPayAllSuper(route, params, hashHistory, "PaymentAllSuperFund");
    };
    goLogin(fun, window.history.length, {isInvestmentAdvisory: this.state.isInvestmentAdvisory,fundCode: _this.props.location.state ? _this.props.location.state.superFundCode : _this.props.location.query.superFundCode,fundName: _this.props.location.state ? _this.props.location.state.superFundName : _this.props.location.query.superFundName,enterType: this.props.location.query.enterType});
  }
  ok() {
    hashHistory.push({
      pathname: "/paymentSuperFund",
    });
  }
  SplitLine = (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div style={{ width: ".06rem", height: ".06rem", border: ".02rem solid #BF9B79", borderRadius: "50%" }} />
      <div style={{ height: ".82rem", borderLeft: ".02rem dotted #BF9B79" }} />
    </div>
  );
  render() {
    let { dispatch } = this.props;
    let { buyStatusDesc, subStatus, endDate, openDate, superData } = this.state;
    const { dataval, manageFeeRate, minLimit, stopProfitOperationInfo = {} } = this.props;
    let superFundCode = this.props.location.query.superFundCode;
  
    const tradeDateString = dataval.tradeDateString ? dataval.tradeDateString : "";
    const buyConfirmDate = dataval.buyConfirmDate ? `${dataval.buyConfirmDate.slice(5)}(${dataval.buyConfirmWeek})` : "";
    const buyIncomeDate = dataval.buyIncomeDate ? `${dataval.buyIncomeDate.slice(5)}(${dataval.buyIncomeWeek})` : "";
    return (
      <div className="container">
        <ModalSelect />
        <NavigatorMain>
          <NHeader title="策略详情" isPaddingBottom={0}/>
        </NavigatorMain>
        <div className="content paddB40" id="TargetProfitDetailIndex" style={{ padding: 0,display:'flex',flex:1,flexDirection:'column',overflowY:'scroll' }}>
          <BaseInformationStop superFundCode={this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode} superFundName={this.props.location.state ? this.props.location.state.superFundName : this.props.location.query.superFundName} />
          <StopPosition />
          <ChangeFundListEntry superFundCode={this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode} />
          <div style={{ flex: "1", overflow: "auto", padding: "0 .1rem" }}>
            <div
              onClick={() => {
                hashHistory.push({
                  pathname: "/BaoGao",
                  state: { superFundCode: superFundCode, dispatch: this.props.dispatch },
                });
              }}
              style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingBottom: "0.2rem", paddingTop: "0.2rem" }}
            >
              <div style={{ fontSize: ".32rem", fontWeight: 500, color: "#333" }}>往期报告</div>
              <img alt="" src={require("../../imgs/youjiantougray@3x.png")} style={{ width: "0.2rem" }} />
            </div>
            <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem" }}>
              <div style={{ paddingTop: "0.3rem", flex: "1", fontSize: ".32rem", fontWeight: 500, color: "#333" }}>服务流程</div>
            </div>
            <div className="zyztDetail_content" style={{ margin: "0", height: "3.8rem", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: ".6rem" }}>
              <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                  <div>{this.SplitLine}</div>
                  <div style={{ margin: "-.12rem .04rem 0" }}>
                    <div style={{ fontSize: ".22rem", lineHeight: ".32rem", color: "#999" }}>{stopProfitOperationInfo.collectDateStr ? stopProfitOperationInfo.collectDateStr.substring(5) : ""}</div>
                    <div style={{ margin: ".2rem 0", textAlign: "center", width: "1.38rem", height: ".5rem", lineHeight: ".5rem", background: "rgba(91, 163, 246, 0.25)", borderRadius: ".24rem", fontSize: ".24rem", color: "#80B4EF" }}>募集期</div>
                    <div style={{ textAlign: "center", color: "#79A2E1", fontSize: ".24rem", lineHeight: ".34rem", fontWeight: 500 }}>产品募集</div>
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div>{this.SplitLine}</div>
                  <div style={{ margin: "-.12rem .04rem 0" }}>
                    <div style={{ fontSize: ".22rem", lineHeight: ".32rem", color: "#999" }}>{stopProfitOperationInfo.investDateStr ? stopProfitOperationInfo.investDateStr.substring(5) : ""}</div>
                    <div style={{ margin: ".2rem 0", textAlign: "center", width: "2.18rem", height: ".5rem", lineHeight: ".5rem", background: "rgba(255, 150, 83, 0.25)", borderRadius: ".24rem 0 0 .24rem", fontSize: ".24rem ", color: "#F09B3D" }}>
                      运作期<span style={{ color: "#9E9D9C" }}>（不止盈）</span>
                    </div>
                    <div style={{ textAlign: "center", color: "#E1AA63", fontSize: ".24rem", lineHeight: ".34rem", fontWeight: 500 }}>产品开始运作</div>
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div>{this.SplitLine}</div>
                  <div style={{ margin: "-.12rem .04rem 0" }}>
                    <div style={{ fontSize: ".22rem", lineHeight: ".32rem", color: "#999", display: "flex", justifyContent: "space-between" }}>
                      <span>{stopProfitOperationInfo.profitDateStr ? stopProfitOperationInfo.profitDateStr.substring(2) : ""}</span>
                      <span>{stopProfitOperationInfo.endDateStr ? stopProfitOperationInfo.endDateStr.substring(2) : ""}</span>
                    </div>
                    <div style={{ margin: ".2rem 0", textAlign: "center", width: "2.78rem", height: ".5rem", lineHeight: ".5rem", background: "#FFE3E3", borderRadius: "0  0.24rem 0.24rem 0", fontSize: ".24rem", color: "#F85B51" }}>
                      运作期<span style={{ color: "#9E9D9C" }}>（达标即止盈）</span>
                    </div>
                    <div style={{ textAlign: "center", color: "#F85B51", fontSize: ".24rem", lineHeight: ".34rem", fontWeight: 500 }}>
                      <p>收益达到年化{Util.toPercent(stopProfitOperationInfo.profitRate)}</p>
                      <p>触发止盈</p>
                    </div>
                  </div>
                  <div>{this.SplitLine}</div>
                </div>
              </div>
              <div style={{ marginTop: ".3rem", paddingLeft: ".3rem", height: ".76rem", lineHeight: ".76rem", background: "#F6F7FA", border: "1PX solid #D6DAE4", borderRadius: ".2rem", fontSize: ".24rem", color: "#999" }}>{`* 本期小常乐${stopProfitOperationInfo.collectEndDateStr ? `${new Date(stopProfitOperationInfo.collectEndDateStr).getMonth() + 1}月${new Date(stopProfitOperationInfo.collectEndDateStr).getDate()}日15点` : "--"}结束募集。`}</div>
            </div>
            <div
              onClick={() => {
                hashHistory.push({
                  pathname: "/JaoYi",
                  state: { dispatch: dispatch, fundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode },
                });
              }}
              style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem", paddingTop: "0.3rem", paddingBottom: "0.3rem" }}
            >
              <div style={{ fontSize: ".32rem", fontWeight: 500, color: "#333" }}>交易规则</div>
              <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem" }}>
                更多
                <img alt="" src={require("../../imgs/youjiantougray@3x.png")} style={{ width: "0.2rem" }} />
              </div>
            </div>
            <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", color: "gray", fontSize: "0.24rem" }}>
              <div style={{ textAlign: "center" }}>
                <div style={{ paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" }}>转入申请</div>
                <img alt="" src={require("../../imgs/sanjiao@3x.png")} style={{ width: "0.2rem", height: "0.2rem" }} />
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" }}>开始确认交易</div>
                <img alt="" src={require("../../imgs/sanjiao@3x.png")} style={{ width: "0.2rem", height: "0.2rem" }} />
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" }}>查看收益</div>
                <img alt="" src={require("../../imgs/sanjiao@3x.png")} style={{ width: "0.2rem", height: "0.2rem" }} />
              </div>
            </div>
            <div style={{ display: "flex", paddingLeft: "0.8rem", paddingRight: "0.8rem", backgroundColor: "#ffffff" }}>
              <div style={{ width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" }}></div>
              <div style={{ flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" }}></div>
              <div style={{ width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" }}></div>
              <div style={{ flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" }}></div>
              <div style={{ width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" }}></div>
            </div>
            <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", fontSize: "0.24rem", color: "#818597" }}>
              <div style={{ flex: 1, textAlign: "left" }}>{tradeDateString}</div>
              <div style={{ flex: 1, textAlign: "center" }}>{buyConfirmDate}</div>
              <div style={{ flex: 1, textAlign: "right" }}>{buyIncomeDate}</div>
            </div>
            <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.2rem", paddingBottom: "0.2rem", color: "gray", fontSize: "0.24rem" }}>
              <div style={{ paddingTop: "0.2rem", paddingBottom: "0.2rem", paddingLeft: "0.2rem", border: "0.02rem solid #D6DAE4", color: "#D6DAE4", backgroundColor: "#F6F7FA", flex: 1, borderRadius: "0.1rem" }}>* 实际确认金额和查看盈亏的时间以基金公司为准</div>
            </div>
            <div
              onClick={() => {
                hashHistory.push({
                  pathname: "/FeiL",
                  state: {
                    manageFeeRate:manageFeeRate
                  },
                });
              }}
              style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem" }}
            >
              <div style={{ paddingTop: "0.3rem", flex: "1", fontSize: ".32rem", fontWeight: 500, color: "#333" }}>费用说明</div>
              <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem", paddingTop: "0.3rem" }}>
                更多
                <img alt="" src={require("../../imgs/youjiantougray@3x.png")} style={{ width: "0.2rem" }} />
              </div>
            </div>
            <div style={{ color: "#333", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", fontSize: "0.28rem", lineHeight: "0.4rem" }}>
              <div style={{ paddingTop: "0.3rem" }}>
                1、投顾服务费：本组合以客户账户资产净值<span style={{ color: "#BF9B79" }}>{manageFeeRate || "--"}</span>（年化）计提投资顾问服务费。每日计提，月度结算。
              </div>
              <div style={{ paddingTop: "0.3rem", paddingBottom: "0.3rem" }}>
                2、申购费与赎回费：本组合<span style={{ color: "#BF9B79" }}>不重复收取申购、赎回费用</span>。成分基金申购费用0至1折，成分基金赎回费用按照基金招募说明书收取。
              </div>
            </div>
            <div
              onClick={() => {
                let code = superData.superFundPolicy?superData.superFundPolicy.policy?superData.superFundPolicy.policy:"":"";
                hashHistory.push({
                  pathname: "/WebView",
                  state: { name: superData.superFundPolicy?superData.superFundPolicy.policyTitle?superData.superFundPolicy.policyTitle:"":"", code: code },
                  query: { code: code },
                });
              }}
              style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem", paddingTop: "0.2rem", paddingBottom: "0.2rem" }}
            >
              <div style={{ fontSize: ".32rem", fontWeight: 500, color: "#333" }}>策略说明书</div>
              <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem" }}>
                查看
                <img alt="" src={require("../../imgs/youjiantougray@3x.png")} style={{ width: "0.2rem" }} />
              </div>
            </div>
            <div style={{ WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem" }}>
              <div style={{ paddingTop: "0.3rem", flex: "1", fontSize: ".32rem", fontWeight: 500, color: "#333" }}>常见问题</div>
            </div>
            <div style={{ color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.3rem", backgroundColor: "#ffffff" }}>
              <div style={{ width: "0.5rem", height: "0.5rem", position: "relative" }}>
                <img alt="" src={require("../../imgs/changjianwentiQ@3x.png")} style={{ width: "0.4rem", height: "0.4rem" }} />
                <div style={{ position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" }}>Q1</div>
              </div>
              <div style={{ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", fontSize: "0.28rem" }}>什么是查理智投？</div>
            </div>
            <div style={{ color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", backgroundColor: "#ffffff" }}>
              <div style={{ width: "0.5rem", height: "0.5rem", position: "relative" }}>
                <img alt="" src={require("../../imgs/changjianxiangqingA@3x.png")} style={{ width: "0.4rem", height: "0.4rem" }} />
                <div style={{ position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" }}>A1</div>
              </div>
              <div style={{ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", lineHeight: "0.4rem", fontSize: "0.28rem" }}>查理智投是华夏基金借助大数据手段，利用人工智能技术，借助算法和模型为投资者制定的理财方案。查理智投力求为不同人生阶段、不同风险收益偏好的投资者提供个性化的投顾服务。</div>
            </div>
            <div style={{ color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.3rem", backgroundColor: "#ffffff" }}>
              <div style={{ width: "0.5rem", height: "0.5rem", position: "relative" }}>
                <img alt="" src={require("../../imgs/changjianwentiQ@3x.png")} style={{ width: "0.4rem", height: "0.4rem" }} />
                <div style={{ position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" }}>Q2</div>
              </div>
              <div style={{ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", fontSize: "0.28rem" }}>基金投顾和基金组合有什么区别？</div>
            </div>
            <div style={{ color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", backgroundColor: "#ffffff", paddingBottom: "0.2rem" }}>
              <div style={{ width: "0.5rem", height: "0.5rem", position: "relative" }}>
                <img alt="" src={require("../../imgs/changjianxiangqingA@3x.png")} style={{ width: "0.4rem", height: "0.4rem" }} />
                <div style={{ position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" }}>A2</div>
              </div>
              <div style={{ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", lineHeight: "0.4rem", fontSize: "0.28rem" }}>相对于组合来说，基金投顾是专业投顾团队根据用户风险等级和投资需求定制化选基，并提供自动调仓，陪伴服务等一站式资产配置服务。</div>
            </div>
            {/* <div style={{WebkitFlexDirection:"row", display:"-webkit-flex", WebkitJustifyContent:"space-between", WebkitAlignItems:"center",backgroundColor:"#ffffff",paddingLeft:"0.3rem",paddingRight:"0.3rem",marginTop:"0.3rem",fontSize:"0.3rem"}}>
                <div style={{paddingBottom:"0.3rem",paddingTop:"0.3rem",flex:"1"}}>
                  风险提示：
                </div>
              </div> */}
            <div style={{ lineHeight: "0.4rem", color: "#5A5A62", fontSize: "0.2rem", paddingLeft: "0.2rem", paddingRight: "0.2rem", paddingBottom: "2rem", marginTop: "0.2rem" }}>风险提示：市场有风险，投资需谨慎。本公司承诺以诚实信用、勤勉尽责的原则提供基金投资顾问服务，提供投资建议并为投资者调仓，但不保证投顾账户一定盈利，也不保证最低收益。组合历史业绩不代表未来收益。本公司提醒投资者接受基金投资顾问服务遵循“买者自负”原则，投资者应结合自身的投资经历、风险承受能力、资产配置需要作出投资决策，投顾账户的投资风险由投资者自行承担。为其他客户创造的收益，并不构成业绩表现的保证。基金投资组合策略的风险特征与单只基金产品的风险特征存在差异。投资者应自行阅读《上海华夏财富投资管理有限公司基金投资顾问服务协议》《风险揭示书》《组合策略说明书》等产品法律文件，自行做出投资选择。基金投顾组合及基金投资遵循“买者自负”原则，投资者应自行承担投资风险。</div>
          </div>
        </div>
        {subStatus == 0 || subStatus == 1 ? (
          <div style={{ paddingTop: "0.12rem", paddingBottom: "0.14rem", color: "#333", display: "flex", justifyContent: "center", backgroundColor: "gray", position: "fixed", bottom: "1.4rem", width: "100%", backgroundColor: "#F6F1E9", fontSize: "0.24rem" }}>
            {minLimit!=null?minLimit:"--"}元起，投顾费率：{manageFeeRate!=null?manageFeeRate:"--"}
          </div>
        ) : null}
        {subStatus == 0 ? (
          <div className="FixedBottomNot_zy">
            <div style={{ backgroundColor: "#BF9B79", color: "#ffffff", fontSize: "0.32rem" }}>{openDate}开放转入</div>
          </div>
        ) : subStatus == 1 ? (
          <div className="FixedBottomNot_zy">
            <div onClick={() => this.goInvesting()} style={{ backgroundColor: "#BF9B79", color: "#ffffff" }}>
              转入
            </div>
          </div>
        ) : subStatus == 2 ? (
          <div className="FixedBottomNot_zy">
            <div style={{ backgroundColor: "#C4C4C4" }} onClick={() => {}}>
              本期已售罄
            </div>
          </div>
        ) : (
          <div className="FixedBottomNot_zy">
            <div style={{ backgroundColor: "#C4C4C4" }} onClick={() => {}}>
              已暂停转入
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { superFundManageRate = {}, superFundTradeLimit = {}, stopProfitOperationInfo = {}, superFundConfirmAndIncomeDate } = state.strategiesDetails;

  return {
    userHasInvested: state.userHasInvested,
    inNeedUpdate: state.inNeedUpdate,
    SuperFoundDetailXCL: state.SuperFoundDetailXCL,
    // payLoading:state.riskInPay.payLoading,
    dataval: superFundConfirmAndIncomeDate||{},
    manageFeeRate: superFundManageRate&&superFundManageRate.manageFeeRate,
    minLimit:superFundTradeLimit&& superFundTradeLimit.minLimit,
    stopProfitOperationInfo: stopProfitOperationInfo||{},
  };
}

export default connect(mapStateToProps)(CacheHOC(TargetProfitDetail,'TargetProfitDetailIndex'));

function add0(m) {
  return m < 10 ? "0" + m : m;
}
function formatTime(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  let time = new Date(shijianchuo);
  let y = time.getFullYear();
  let m = time.getMonth() + 1;
  let d = time.getDate();
  // let h = time.getHours();
  // let mm = time.getMinutes();
  // let s = time.getSeconds();
  return y + "." + add0(m) + "." + add0(d);
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/TargetProfitDetail.js